import React, { useState, useCallback, useEffect } from "react";

import TwoColumnLayout from "../../components/layouts/TwoColumnLayout";
import ListItem from "../../components/list-item/ListItem";
import leftColumnList from "./leftColumnList";
import rightColumnList from "./rightColumnList";
import { useGetProfileContentQuery } from "../../app/services/creatorProfile";

// 表を含むメニュー項目は右カラムの読み幅制限（756px）を外して全幅で編集できるようにする
const WIDE_RIGHT_ITEMS = new Set(["mySiteWorks", "mySiteReviews", "mySiteFooter"]);

const MyProfile = () => {
  // デフォルトで最初のメニュー項目を選択状態にする
  const [selectedItem, setSelectedItem] = useState("mySitePublic");
  const [layoutSetShowRightColumn, setLayoutSetShowRightColumn] = useState(null);

  // メニューのデザイン状態（フルスクリーン / バナー）を実データに合わせる。
  const { data: contentResp } = useGetProfileContentQuery();
  const designStatus =
    contentResp?.data?.header?.type_header === "banner" ? "バナー" : "フルスクリーン";
  const isPublished = contentResp?.data?.is_published ?? false;

  // 非公開時はメニューが「公開範囲とURL」のみになるため、別項目を選択中だった場合は
  // そこへ戻す（隠れたセクションの編集画面が残らないようにする）。
  useEffect(() => {
    if (!isPublished && selectedItem !== "mySitePublic") {
      setSelectedItem("mySitePublic");
    }
  }, [isPublished, selectedItem]);

  // TwoColumnLayoutからsetShowRightColumn関数を受け取るコールバック
  const getSetShowRightColumn = useCallback((setShowRightColumnFunc) => {
    setLayoutSetShowRightColumn(() => setShowRightColumnFunc);
  }, []);

  const renderListItems = (items) => {
    return items.map((item) => (
      <ListItem
        key={item.id}
        name={item.name}
        status={item.status}
        alert={item.alert}
        onClick={item.onClick}
        size={item.size}
        isSelected={selectedItem === item.id}
        hasBorderBottom={item.hasBorderBottom}
      />
    ));
  };

  // leftColumnListに渡すpropsオブジェクトを生成
  const leftColumnProps = {
    setSelectedItem,
    setShowRightColumn: value => {
      if (layoutSetShowRightColumn) {
        layoutSetShowRightColumn(value);
      }
    },
    designStatus,
    isPublished,
  };

  // 左カラムのコンテンツ
  const leftColumnContent = renderListItems(
    leftColumnList(leftColumnProps)
  );

  // 右カラムのコンテンツ（常にメニューと紐づく情報を表示）
  const rightColumnContent = rightColumnList[selectedItem];

  return (
    <TwoColumnLayout
      leftColumnContent={leftColumnContent}
      rightColumnContent={rightColumnContent}
      getSetShowRightColumn={getSetShowRightColumn}
      wideRightColumn={WIDE_RIGHT_ITEMS.has(selectedItem)}
    />
  );
};

export default MyProfile;
